import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  GROUP_PERMISSIONS_LIST,
  GROUP_PERMISSIONS_NEW,
  GROUP_PERMISSIONS_EDIT,
  GROUP_PERMISSIONS_DELETE,
  GROUP_PERMISSIONS_TYPES_LIST,
} from "./actionTypes"

import {
  groupPermissionsListSuccess,
  groupPermissionsListError,
  groupPermissionsNewSuccess,
  groupPermissionsNewError,
  groupPermissionsDeleteSuccess,
  groupPermissionsDeleteError,
  groupPermissionsTypesListSuccess,
  groupPermissionsTypesListError,
} from "./actions"

import {
  apiGetGroupPermissionsList,
  apiPostGroupPermissionsNew,
  apiPatchGroupPermissionsEdit,
  apiDeleteGroupPermissionsDelete,
  apiGetGroupPermissionsTypesList,
} from "../../../api/calls/groupPermissions"

function* groupPermissionsList({payload: data}) {
  try {
    const response = yield call(apiGetGroupPermissionsList, data)
    yield put(groupPermissionsListSuccess(response))
  } catch (error) {
    yield put(groupPermissionsListError(error))
  }
}

function* groupPermissionsNew({payload: data}) {
  try {
    const response = yield call(apiPostGroupPermissionsNew, data)
    yield put(groupPermissionsNewSuccess(response))
  } catch (error) {
    yield put(groupPermissionsNewError(error))
  }
}

function* groupPermissionsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchGroupPermissionsEdit, data)
    yield put(groupPermissionsNewSuccess(response))
  } catch (error) {
    yield put(groupPermissionsNewError(error))
  }
}

function* groupPermissionsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteGroupPermissionsDelete, data)
    yield put(groupPermissionsDeleteSuccess(response))
  } catch (error) {
    yield put(groupPermissionsDeleteError(error))
  }
}

function* groupPermissionsTypesList({payload: data}) {
  try {
    const response = yield call(apiGetGroupPermissionsTypesList, data)
    yield put(groupPermissionsTypesListSuccess(response))
  } catch (error) {
    yield put(groupPermissionsTypesListError(error))
  }
}

export function* watchGroupPermissionsList() {
  yield takeEvery(GROUP_PERMISSIONS_LIST, groupPermissionsList);
}

export function* watchGroupPermissionsNew() {
  yield takeEvery(GROUP_PERMISSIONS_NEW, groupPermissionsNew);
}

export function* watchGroupPermissionsEdit() {
  yield takeEvery(GROUP_PERMISSIONS_EDIT, groupPermissionsEdit);
}

export function* watchGroupPermissionsDelete() {
  yield takeEvery(GROUP_PERMISSIONS_DELETE, groupPermissionsDelete);
}

export function* watchGroupPermissionsTypesList() {
  yield takeEvery(GROUP_PERMISSIONS_TYPES_LIST, groupPermissionsTypesList);
}

function* groupPermissionsSaga() {
  yield all([
    fork(watchGroupPermissionsList),
    fork(watchGroupPermissionsNew),
    fork(watchGroupPermissionsEdit),
    fork(watchGroupPermissionsDelete),
    fork(watchGroupPermissionsTypesList),
  ]);
}

export default groupPermissionsSaga
